import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AddTransferTemplatePage, { getDefaultData } from "components/pages/AddTransferTemplatePage";
import Classes from "model";

/**
 * @name CaptureAddTemplateMainToSelected
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureAddTemplateMainToSelected(props) {
    // Initialize all the model classes
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "template", "name" ], "Sample")
    .update([ "template", "fromAccount" ], "6")
    .update([ "template", "toAccount" ], "5")
    .submit();

    return <AddTransferTemplatePage data={ data }  />
}